import { AvailabilityFilterModel } from "@/models/availability";
import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";

import store from "./index";

export interface AvalabilityState {
  filter?: AvailabilityFilterModel | null;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "availability",
})
class Availability extends VuexModule implements AvalabilityState {
  filter: AvailabilityFilterModel | null = null;

  get getFilter() {
    return this.filter;
  }

  @Mutation
  setFilter(filter: AvailabilityFilterModel | null) {
    this.filter = filter;
  }
}

export const AvailabilityModule = getModule(Availability);
